import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { User } from '../types/types';

import { userQueryKeys } from './query-keys';

export function getMe(): Promise<User> {
  return acceso360Client.get(`/iam/api/v1/users/me`).then(({ data }) => data);
}
type QueryFnType = typeof getMe;

interface UseMeParams {
  config?: QueryConfig<QueryFnType>;
}

export function useMe({ config = {} }: UseMeParams = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: userQueryKeys.me(),
    queryFn() {
      return getMe();
    },
  });
}
